/**
 * @generated SignedSource<<74b6d70be4014b8953bef510f9b14487>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContractDownloadBox_order$data = {
  readonly orderNr: string | null;
  readonly uuid: string;
  readonly " $fragmentType": "ContractDownloadBox_order";
};
export type ContractDownloadBox_order$key = {
  readonly " $data"?: ContractDownloadBox_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContractDownloadBox_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContractDownloadBox_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderNr",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "e1bd711aa061c2c1e594bd7ac6464b21";

export default node;
